import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, apiErr } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function ForcePasswordChange() {
  const { setUser, logout } = useAuth();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Kata sandi minimal 8 karakter");
    if (pw !== pw2) return toast.error("Konfirmasi kata sandi tidak cocok");
    setLoading(true);
    try {
      const r = await api.post("/auth/change-password", { new_password: pw });
      setUser(r.data);
      toast.success("Kata sandi berhasil diperbarui");
      navigate("/");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="force-change-form">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-100 text-amber-700">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <div>
            <h1 className="font-heading text-xl font-bold text-slate-900">Ganti Kata Sandi</h1>
            <p className="text-sm text-slate-500">Demi keamanan, buat kata sandi baru sebelum melanjutkan.</p>
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="pw">Kata Sandi Baru</Label>
          <Input id="pw" type="password" value={pw} data-testid="force-pw"
            placeholder="Minimal 8 karakter" onChange={(e) => setPw(e.target.value)} required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="pw2">Ulangi Kata Sandi Baru</Label>
          <Input id="pw2" type="password" value={pw2} data-testid="force-pw2"
            onChange={(e) => setPw2(e.target.value)} required />
        </div>
        <Button type="submit" disabled={loading} data-testid="force-submit"
          className="w-full bg-blue-800 hover:bg-blue-900">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Simpan & Lanjut
        </Button>
        <button type="button" onClick={logout} data-testid="force-logout"
          className="w-full text-center text-sm text-slate-500 hover:underline">
          Keluar
        </button>
      </form>
    </div>
  );
}
